import React, { useState } from 'react';
import Navbar from './QANavbar';
import Overview from './Tabs/Safety';
import Checklists from './Tabs/SoilP';
import Reports from './Tabs/Danger';
import Statistics from './Tabs/Reports';

const ViewQA = () => {
  const [currentSection, setCurrentSection] = useState('Quality Inspections');

  const sections = ['Quality Inspections','Safety', 'Soil Predictions', 'Danger Prediction'];

  const handleSectionClick = (section) => {
    setCurrentSection(section);
  };

  const renderContent = () => {
    switch (currentSection) {
      case 'Safety':
        return <Overview />;
      case 'Soil Predictions':
        return <Checklists />;
      case 'Danger Prediction':
        return <Reports />;
      case 'Quality Inspections':
        return <Statistics />;
      default:
        return <Statistics />;
    }
  };

  return (
    <div className="min-h-screen dark:bg-gray-900 transition-colors duration-300">
      {/* Navbar Section */}
      <Navbar sections={sections} onSectionClick={handleSectionClick} />



        {/* Content Display Section */}
        <div className="flex-1 shadow-lg rounded-sm mt-4 mr-4">
          {renderContent()}
        </div>
    </div>
  );
};

export default ViewQA;
